import { render } from "./MembersFlagged.vue?vue&type=template&id=09f758c7&scoped=true"
import script from "./MembersFlagged.vue?vue&type=script&lang=js"
export * from "./MembersFlagged.vue?vue&type=script&lang=js"

import "./MembersFlagged.vue?vue&type=style&index=0&id=09f758c7&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f758c7"]])

export default __exports__